<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="企业名称：">
            <el-input clearable v-model="filterForm.aab004" placeholder="请输入企业名称"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2_" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler" />

    <el-dialog
      title="导入提示"
      :close-on-click-modal="false"
      :visible.sync="isShowImportTip"
      :append-to-body="true"
      width="1000px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>
  </div>
</template>

<script>
import enum_shengting from '@/publicData/enum_shengting'
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
import AreaPicker from '@/components/AreaPicker_3'
// import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation },
  data() {
    return {
      sign: 'shengting_qiye',
      dialogTitle: '企业信息',
      fileName: 'qiyexinxi',
      importTipKey: 'aab004',
      importTiplabel: '单位名称',

      enum_shengting: enum_shengting,

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },

        // { key: 'cid', label: '外部系统主键' },
        { key: 'aab004', label: '单位名称', fixed: true },
        { key: 'aab003', label: '组织机构代码' },
        { key: 'aab007', label: '工商营业执照号码' },
        { key: 'aab022', label: '所属行业' },
        { key: 'aab019', label: '单位类型' },
        { key: 'aab020', label: '经济类型' },
        { key: 'aab049', label: '注册资金' },
        { key: 'aab056', label: '人员规模' },
        // { key: 'aab301', label: '所属地区行政区划代码' },
        { key: 'aae006', label: '单位地址' },
        { key: 'aae007', label: '邮政编码' },
        // { key: 'aae392', label: '单位网站' },
        // { key: 'aab092', label: '单位简介' },

        { key: 'aab013', label: '法定代表人' },
        { key: 'aab015', label: '法定代表人电话' },
        { key: 'aae004', label: '联系人' },
        { key: 'aae005', label: '联系电话' },
        { key: 'acb501', label: '联系手机' },
        { key: 'aae387', label: '传真电话' },
        { key: 'aae159', label: '电子邮箱' },
        // { key: 'lng', label: '企业百度地图经度' },
        // { key: 'lat', label: '企业百度地图纬度' },
        // { key: 'ace760', label: '原始网页地址(url)' },
        { key: 'ace762', label: '是否有效' },
        { key: 'acb116', label: '公开联系方式标识' },
        { key: 'ace761', label: '单位性质' },
        { key: 'status_', label: '状态' },
        { key: 'importError', label: '失败原因' },
      ],
    }
  },
  computed: {
    importAction() {
      return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
    },
    formItems() {
      return [
        // { type: 'text', key: 'cid', label: '外部系统主键' },
        { type: 'text', key: 'aab004', label: '单位名称' },
        { type: 'text', key: 'aab003', label: '组织机构代码' },
        { type: 'text', key: 'aab007', label: '工商营业执照号码' },
        { type: 'select_s', key: 'aab022', label: '所属行业', options: this.enum_shengting.suoshuhangye },
        { type: 'select_s', key: 'aab019', label: '单位类型', options: this.enum_shengting.danweileixing },
        { type: 'select_s', key: 'aab020', label: '经济类型', options: this.enum_shengting.jingjileixing },
        { type: 'text', key: 'aab049', label: '注册资金' },
        { type: 'select_s', key: 'aab056', label: '人员规模', options: this.enum_shengting.renyuanguimo },
        // { type: 'text', key: 'aab301', label: '所属地区行政区划代码' },
        { type: 'text', key: 'aae006', label: '单位地址' },
        { type: 'text', key: 'aae007', label: '邮政编码' },
        { type: 'text', key: 'aae392', label: '单位网站' },
        { type: 'text', key: 'aab092', label: '单位简介' },
        { type: 'text', key: 'aab013', label: '法定代表人' },
        { type: 'text', key: 'aab015', label: '法定代表人电话' },
      ]
    },
    formItems2() {
      return [
        { type: 'text', key: 'aae004', label: '联系人' },
        { type: 'text', key: 'aae005', label: '联系电话' },
        { type: 'text', key: 'acb501', label: '联系手机' },
        { type: 'text', key: 'aae387', label: '传真电话' },
        { type: 'text', key: 'aae159', label: '电子邮箱' },
        { type: 'text', key: 'lng', label: '企业百度地图经度' },
        { type: 'text', key: 'lat', label: '企业百度地图纬度' },
        { type: 'text', key: 'ace760', label: '原始网页地址(url)' },
        { type: 'select_s', key: 'ace762', label: '是否有效', options: this.enum_shengting.youxiaoxing },
        { type: 'select_s', key: 'acb116', label: '公开联系方式标识', options: this.enum_shengting.shifou },
        { type: 'text', key: 'ace761', label: '单位性质' },
        // { type: 'text', key: 'status_', label: '状态' },
        // { type: 'text', key: 'importError', label: '失败原因' },
      ]
    },
    formItems2_() {
      return [
        ...this.formItems2,
        { type: 'text', key: 'status_', label: '状态' },
        { type: 'text', key: 'importError', label: '失败原因' },
      ]
    },
  },
  methods: {
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result, this.isCreate)
      // console.log(result, this.selectData)
      let rData = {}
      let areaId = this.$refs.AreaPicker.findAreaId()
      let {
        id,
        aab004,
        aab003,
        aab007,
        aab022,
        aab019,
        aab020,
        aab049,
        aab056,
        aae006,
        aae007,
        aae392,
        aab092,
        aab013,
        aab015,
        aae004,
        aae005,
        acb501,
        aae387,
        aae159,
        lng,
        lat,
        ace760,
        ace762,
        acb116,
        ace761,
      } = result
      if (this.isCreate) {
        rData = {
          aab004,
          aab003,
          aab007,
          aab022,
          aab019,
          aab020,
          aab049,
          aab056,
          aae006,
          aae007,
          aae392,
          aab092,
          aab013,
          aab015,
          aae004,
          aae005,
          acb501,
          aae387,
          aae159,
          lng,
          lat,
          ace760,
          ace762,
          acb116,
          ace761,
          areaId,
        }
        console.log(areaId)
        // console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('新建成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        const mapList = [
          'aab004',
          'aab003',
          'aab007',
          'aab022',
          'aab019',
          'aab020',
          'aab049',
          'aab056',
          'aae006',
          'aae007',
          'aae392',
          'aab092',
          'aab013',
          'aab015',
          'aae004',
          'aae005',
          'acb501',
          'aae387',
          'aae159',
          'lng',
          'lat',
          'ace760',
          'ace762',
          'acb116',
          'ace761',
          'areaId',
        ]
        mapList.forEach(x => {
          // if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          // }
        })
        // rData.id = this.selectData.id // 绑定修改的数据id
        // console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })

        // this.$api.util_modify(this.sign, rData).then(res => {
        //   if (res.data.status == 0) {
        //     this.$message.success('修改成功')
        //     this.$refs.DialogEdit.isShowDialog = false
        //     this.$refs.DialogEdit.clearHandler()
        //     this.searchHandler()
        //   } else { this._status(res.data) }
        // })
      }
    },
    getData(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R.map(x => {
            x.status_ = ['', '未校验', '通过', '失败'][x.status]
            return x
          })
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    const mapList1 = ['search','create','modify','import']
    mapList1.forEach(x => {
      this.btnShow[x] = true
    })
    const mapList = ['export','delete']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}
</style>